export const email_template_config = {
  SIGNUP_OTP_TEMPLATE: 1,
  SIGNIN_OTP_TEMPLATE: 2,
  ENABLE_PASSWORD_OTP_TEMPLATE: 3,
  RESET_PASSWORD_TEMPLATE: 4,
  VERIFY_EMAIL_ADDRESS: 5,
};
